export const getWorkspaceSettingsLink = () => {
  return (workspaceId: number | 'last') => `/workspaces/${workspaceId}/settings`;
};
